import { PropsWithChildren, useMemo } from 'react';
import { motion } from 'framer-motion';

import { OutletsMap } from 'components/OutletsMap';
import { usePageTextContent } from 'context/pageTextContent';
import { useSearchPageStore } from '../../useSearchPageStore';

interface Props extends PropsWithChildren {
  stores: AdaptedStore[];
}

export const MapSection = (props: Props) => {
  const { stores, children } = props;

  const { content } = usePageTextContent<SearchPageContent>();

  const {
    enableCookieMessage,
    mapPlaceholderUrl,
    mapZoomInstructions,
    mapInstructionsMobile,
  } = content;

  const isMapOpen = useSearchPageStore(state => state.isMapOpen);

  const mapAnimation = useMemo(() => {
    if (!isMapOpen) return { x: '100%', opacity: 0, width: 0 };

    return { x: 0, opacity: 1, minWidth: '50vw' };
  }, [isMapOpen]);

  return (
    <OutletsMap
      as={motion.div}
      initial={{ x: '100%', opacity: 0 }}
      animate={mapAnimation}
      h={['82.5vh', '82.5vh', 'calc(100vh - 5rem)']}
      w={['100vw', '100vw', '50vw']}
      top="5rem"
      right={0}
      pos={['unset', 'unset', 'sticky']}
      outlets={stores}
      content={{
        enableCookieMessage,
        mapPlaceholderUrl,
        mapZoomInstructions,
        mapInstructionsMobile,
      }}
    >
      {children}
    </OutletsMap>
  );
};
